import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import NewCalendarGeneralTabs from 'components/tabs-components/create_new_calendar/general';
import PublicHolidays from 'components/tabs-components/create_new_calendar/public_holidays';
import useMember from 'hooks/useMember';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import useAuth from 'hooks/useAuth';
import { api } from 'utils/apiRoutes';
import { GET } from 'utils';
import { Loading } from 'components';

const PublicHolidayDetail = () => {
  const { getPublicHolidayById } = useMember();
  const [activeTab, setActiveTab] = useState('1');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const { slug } = useParams();
  useEffect(() => {
    setLoading(true);
    GET(`${api.getPublicHoliday}${location?.state?.item?.id}/`).then((res) => {
      setData(res);
      setLoading(false);
    }).catch();
  }, []);

  if (loading) return <Loading />;
  return (
    <div>
      <GeneralHeader
        pageTitle={location?.state?.item?.name}
        icon="/icons/new_calendar.svg"
        child={
          <div style={{ marginTop: '100px' }}>
            <Tabs
              style={{ marginTop: '100px' }}
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={(key) => { setActiveTab(key) }}
              items={[
                {
                  key: '1',
                  label: (
                    <div style={{ color: activeTab === '1' ? '#0E3063' : '#757575', fontSize: '20px', fontWeight: 600, margin: '0px 10px' }}>
                      General
                    </div>
                  ),
                  children: <NewCalendarGeneralTabs data={data?.data} />,
                },
                {
                  key: '2',
                  label: (
                    <div style={{ color: activeTab === '2' ? '#0E3063' : '#757575', fontSize: '20px', fontWeight: 600, margin: '0px 10px' }}>
                      Public Holidays
                    </div>
                  ),
                  children: (
                    <PublicHolidays
                      data={data?.data}
                      finalData={data?.data}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default PublicHolidayDetail;
